import { useField } from 'react-final-form';
import { Checkbox } from '@gandi/ui';
import { jsx as _jsx } from "react/jsx-runtime";
export function CheckboxField({
  name,
  ...props
}) {
  const {
    input: {
      type,
      multiple,
      ...inputRest
    }
    // $FlowFixMe[prop-missing]
  } = useField(name, {
    type: 'checkbox'
  });
  return /*#__PURE__*/_jsx(Checkbox, {
    ...inputRest,
    ...props
  });
}